module.exports = __webpack_public_path__ + "static/img/logo_zxyp.112c7583.png";